// Локальный учёт просмотренных баннеров «Что нового» — для анонимных
// посетителей. Залогиненные учитываются на сервере (POST /whats-new/:id/seen).
const KEY = "whatsNewSeen";

export const getSeenWhatsNew = (): number[] => {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const addSeenWhatsNew = (id: number): void => {
  try {
    const seen = getSeenWhatsNew();
    if (!seen.includes(id)) {
      localStorage.setItem(KEY, JSON.stringify([...seen, id]));
    }
  } catch {
    // no-op
  }
};
